import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CarbonHubAvailableDataPointResponse,
  CarbonHubOrganization,
  CarbonHubOrganizationUnit,
} from '@/slices/carbonHub/carbonHub.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

type GetOrganizationUnitsInput = {
  organizationId: string;
};

type GetAvailableDataPointsInput = {
  organizationId: string;
  year?: number;
};

const carbonHubApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/carbon-hub',
  }),
  reducerPath: 'carbonHub',
  tagTypes: ['CarbonHubOrganizations', 'CarbonHubOrganizationUnits'],
  endpoints: (build) => ({
    getOrganizations: build.query<CarbonHubOrganization[], void>({
      query: () => ({
        url: '/organizations',
        method: 'GET',
      }),
      transformResponse: (response: CarbonHubOrganization[]) => response ?? [],
      providesTags: [{ type: 'CarbonHubOrganizations', id: 'LIST' }],
    }),
    getOrganizationUnits: build.query<
      CarbonHubOrganizationUnit[],
      GetOrganizationUnitsInput
    >({
      query: ({ organizationId }) => ({
        url: `/${organizationId}/units`,
        method: 'GET',
      }),
      transformResponse: (response: CarbonHubOrganizationUnit[]) =>
        response ?? [],
      providesTags: (_result, _error, { organizationId }) => [
        { type: 'CarbonHubOrganizationUnits', id: organizationId },
      ],
    }),
    getAvailableDataPoints: build.query<
      CarbonHubAvailableDataPointResponse,
      GetAvailableDataPointsInput
    >({
      query: ({ organizationId, year }) => ({
        url: `/${organizationId}/available-data-points`,
        method: 'GET',
        params: undefined === year ? undefined : { year },
      }),
      transformResponse: (response: CarbonHubAvailableDataPointResponse) =>
        response,
    }),
  }),
});

export default carbonHubApi;
